// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xM5x","col":"styles_col__3Qfa_"};